import { Component, EventEmitter, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Integration } from '../../../../core/models/integration';
import { IntegrationDao } from '../../../../core/services/dao/integrationDao';
import { User } from '../../../../core/models/user';
import { IntegrationInvite } from '../../../../core/models/integrationInvite';

@Component({
  selector: 'google-analytics',
  templateUrl: './google-analytics.component.html',
  styleUrls: ['./google-analytics.component.scss']
})
export class GoogleAnalyticsComponent {
  private subs = [];

  loading = false;
  creating = false;
  createdIntegration: any = {};
  existingIntegrations = [];

  trackingId;
  user: User;
  invites: IntegrationInvite[];
  description: string = '';
  showAccounts = false;
  integrationName;
  integrationType;
  noAccounts = false;
  isAdmin = false;
  emitter: EventEmitter<any>;

  constructor(
    public dialogRef: MatDialogRef<GoogleAnalyticsComponent>,
    public integrationDao: IntegrationDao,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.existingIntegrations = this.data.existingIntegrations;
    this.user = this.data.user;
    this.isAdmin = this.user ? this.user.isAdmin : false;
    this.invites = this.data.invites.filter(i => i.integrations.includes(this.data.type));
    this.description = this.data.description;
    this.integrationName = this.data.name;
    this.integrationType = this.data.type;
    if (this.existingIntegrations.length === 0) {
      this.creating = true;
      this.noAccounts = true;
    }
  }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  onViewInvitesClick() {
    this.emitter.emit(this.integrationType);
    this.dialogRef.close();
  }

  addAnother(e) {
    this.creating = true;
  }

  toggleShowAccounts() {
    this.showAccounts = !this.showAccounts;
  }

  save() {
    this.createdIntegration.trackingId = this.trackingId;
    this.createdIntegration.friendlyName = this.trackingId;
    this.createdIntegration.brand = this.data.brand;
    this.createdIntegration.type = 'google_analytics';
    // let sub = this.integrationDao.createIntegration(this.createdIntegration).subscribe(
    //   (result: Integration) => {
    //     this.createdIntegration = result;
    //     this.loading = false;
    //     this.dialogRef.close(this.createdIntegration);
    //   },
    //   err => console.error(err)
    // );
    // this.subs.push(sub);
  }
}
